import { IVesselCrew } from "../types";
import moment from "moment";
import { ESIGNAL_REPORT_TYPE_VAL } from "./types";
import { CNRColumnsVersion } from "./constants";
function chunkString(str: string, len: number) {
	const size = Math.ceil(str.length / len);
	const r = Array(size);
	let offset = 0;
	for (let i = 0; i < size; i++) {
		r[i] = str.substr(offset, len);
		offset += len;
	}
	return r;
}

export default {
	/**
	 * Crew Object of server is not with exact format of IVesseCrew.. So this function is required to convert it
	 * @param crewFromServer - Crew Object got from server and is incompatible with clients IVesseCrew Format
	 */
	getCrewFromServerCrewData(crewFromServer: any): IVesselCrew {
		return {
			designation: crewFromServer.designation?.name,
			type: crewFromServer.designation?.type,
			// fromDate: moment(crewFromServer.fromDate).format("YYYY-MM-DD"),
			// toDate: moment(crewFromServer.toDate).format("YYYY-MM-DD"),
			id: crewFromServer.id,
			// image: crewFromServer.image,
			// userId: crewFromServer.userId,
			name: crewFromServer.name,
			staffId: crewFromServer.staffId,
			vesselId: crewFromServer.designation.vesselId,
		};
	},
	stringToMacAddress(macString: string) {
		const chunks = chunkString(macString, 2);
		let formattedMac = "";
		chunks.map((chunk, index) => {
			index === 0
				? (formattedMac = `${chunk}`)
				: (formattedMac = `${formattedMac}${chunk}`);
		});
		return formattedMac;
	},
	macAddressToString(macAddressFormat: string) {
		const aadhar = macAddressFormat.replace(/:/g, "");
		return aadhar;
	},
};

export function getPaddedDate(date: string) {
	const day = moment(date).format("Do MMM");
	const monthPart = day.slice(-4);
	const datePart = day.slice(0, -4);

	const modifiedDatePart = datePart.length === 3 ? `0${datePart}` : datePart;
	return modifiedDatePart + monthPart;
}

export function formatSRTypeValues(signalReportType?: ESIGNAL_REPORT_TYPE_VAL){
	// One place in config as Streaming, can't change there so
	if(signalReportType === ESIGNAL_REPORT_TYPE_VAL.STEAMING) return 'steaming' //ESIGNAL_REPORT_TYPE_VAL.STEAMING contains value as 'streaming'
	return signalReportType
}

export const validateNumberField = (value: string, restrictNo: { min: number, max: number, decimals: number }) => {
	const { min, max, decimals } = restrictNo;
	if (value) {
		if (Number(value) < min || Number(value) > max) {
			return false;
		}
		const valueArr = value.split('.');
		if (valueArr.length >= 2 && valueArr[1].length > decimals) {
			return false;
		}
	}
	return true;
}

export function getTimelineRange(timeline: Record<string, any>[]) {
	// Helper function to get starting and ending dates for a report based on its timeline
    if (!timeline?.length) return { startingDate: null, endingDate: null, startOffset: null, endOffset: null };

    let startingDate: string | null = null;
    let endingDate: string | null = null;
    let startOffset: string | null = null;
    let endOffset: string | null = null;

    for (const report of timeline) {
        if (report?.from_local_date && report?.from_local_time) {
            const start = `${report.from_local_date}T${report.from_local_time}:00`;
            if (!startingDate || start < startingDate) {
                startingDate = start;
                startOffset = report.from_zd ?? null;
            }
        }
        if (report?.to_local_date && report?.to_local_time) {
            const end = `${report.to_local_date}T${report.to_local_time}:00`;
            if (!endingDate || end > endingDate) {
                endingDate = end;
                endOffset = report.to_zd ?? null;
            }
        }
    }

    return { startingDate, endingDate, startOffset, endOffset };
}

// Helpers for CNR Table
export const saveStoredColumns = (columns: any) => {
	try {
 		localStorage.setItem('selectedCNRColumns', JSON.stringify({ version: CNRColumnsVersion, columns }));
 	} catch(error) {
		console.error('Failed to save CNR columns:', error);
 	}
};
export const getStoredColumns = () => {
	// Return empty if version does not match, resetting the locally saved columns
	try {
		const stored = JSON.parse(localStorage.getItem('selectedCNRColumns') || '{}');
		if (stored?.version !== CNRColumnsVersion) return {};
		return stored.columns ?? {};
	} catch(error) {
		console.error('Failed to fetch CNR columns:', error);
		return {};
	}
};